import { render, staticRenderFns } from "./MealSlotSegment.vue?vue&type=template&id=838efa26&scoped=true"
import script from "./MealSlotSegment.vue?vue&type=script&lang=js"
export * from "./MealSlotSegment.vue?vue&type=script&lang=js"
import style0 from "./MealSlotSegment.vue?vue&type=style&index=0&id=838efa26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838efa26",
  null
  
)

export default component.exports